import reducer from 'src/utils/redux/reducer';
import {
  FILTER_OPEN, FILTER_CLOSE,
  MENU_OPEN, MENU_CLOSE,
} from 'src/services/ui/types';

// --- initialState ---

export const initialState = {
  filter: {
    isOpened: false,
  },
  menu: {
    isOpened: false,
  },
};

// --- handlers ---

const handleSetInitial = () => initialState;

const handleFilterOpen = state => ({
  ...state,
  filter: {
    ...state.filter,
    isOpened: true,
  },
});

const handleFilterClose = state => ({
  ...state,
  filter: {
    ...state.filter,
    isOpened: false,
  },
});

const handleMenuOpen = state => ({
  ...state,
  menu: {
    ...state.menu,
    isOpened: true,
  },
});

const handleMenuClose = state => ({
  ...state,
  menu: {
    ...state.menu,
    isOpened: false,
  },
});

const handlers = {
  'SET_INITIAL': handleSetInitial,
  [FILTER_OPEN]: handleFilterOpen,
  [FILTER_CLOSE]: handleFilterClose,
  [MENU_OPEN]: handleMenuOpen,
  [MENU_CLOSE]: handleMenuClose,
};

// --- reducerFactory ---

export default flows => reducer({ initialState, handlers, flows });